// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingSectionHeading_root__3tLhf","description":"EditListingSectionHeading_description__1kujB"};